import { MButton } from '@Components/Base';
import { ButtonProps } from 'antd';
import classNames from 'classnames';
import { FC } from 'react';
import styles from './TabSelectBtn.module.css';

interface TabSelectBtn extends Omit<ButtonProps, 'variant' | 'color'> {
  active: boolean;
}

const TabSelectBtn: FC<TabSelectBtn> = ({ active = false, ...options }) => {
  return (
    <MButton
      {...options}
      className={classNames(options.className, active && styles.active)}
      type="text"
    />
  );
};
export default TabSelectBtn;
